import React from 'react'
import { useTranslation } from 'react-i18next';
import PassesList from './PassesList';

const TicketsTab = () => {
    const { t } = useTranslation();
  return (
    <div className="tab-content__container">
        <h5>{t('twoje_bilety_i_karnety')}</h5>

        <PassesList />
        
    </div>
  )
}

export default TicketsTab